import React from "react";
import Modal from "../../../../components/elements/Modal";
import ManageResource from "../ManageResource";

function ManageResourceModal({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) {
  return (
    <Modal
      isOpen={open}
      setIsOpen={close}
      size="lg"
      title={data?._id ? "Update One" : "Create New "}
    >
      <ManageResource getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
}

export default ManageResourceModal;
